module.exports = __webpack_public_path__ + "img/ki.81ec16ad.svg";